import { axiosClientAuth } from '../../utils'
import {REGULATORY_OPERATOR_KEY} from '../../../config/countryConfig'

export const PE_TM_QUERY_KEY = 'pe-tm-list'

export interface PeTmFetchParams {
  page?: number
  page_size?: number
  search?: string
  from_date?: string
  to_date?: string
}

export const fetchPeTm = (params: PeTmFetchParams = {}) =>
  axiosClientAuth
    .get('/auth/users/pe-tm/', {
      params,
      transformResponse: [
        (data: string) => {
          const safe = data.replace(/"id"\s*:\s*(\d{15,})/g, '"id":"$1"')
          return JSON.parse(safe)
        },
      ],
    })
    .then((res) => ({
    count: res.data.data.count as number,
    results: res.data.data.results.map((item: any) => ({
      uuid: String(item.id),
      name: item.name,
      created_at: item.created_at,
      node: {
        node_name: item.type,
        node_id: String(item.id),
        is_blacklisted: item.is_blacklisted,
      },
      ip_count: {
        total: item.total_ips,
        whitelisted: item.whitelisted?.[REGULATORY_OPERATOR_KEY] ?? 0,
        blacklisted: item.blacklisted?.[REGULATORY_OPERATOR_KEY] ?? 0,
      },
    })),
  }))
